import React, { useEffect } from 'react';
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { Chip, Typography } from '@mui/material';
import { ColumnHeader, SimpleTable } from './components/SimpleTable';
import {
  FiltersBar,
  SelectOTPs,
  SelectSubscriptionStatus,
} from './CrmFiltersBar';
import TOOLTIPS from './tooltips';
import { SubscriptionStatus } from './components/SubscriptionStatus';
import { mixTrack } from '@services/mixpanel';

export type OtpDto = {
  id: number;
  name: string;
  email: string;
  isEmailVerified: boolean;
  marketingConsent: boolean;
  status: string;
  programs: Array<{ id: number; name: string }>;
};

const columns = [
  {
    title: 'Name',
    field: 'name',
  },
  {
    title: <ColumnHeader label="Email" title={TOOLTIPS.email} />,
    render: (row: OtpDto) => (
      <div className="flex items-center">
        {row.isEmailVerified && row.marketingConsent ? (
          <Icon icon={faBadgeCheck} className="text-primary mr-2" />
        ) : null}
        <span className="select-all">
          {row.marketingConsent ? row.email : row.email?.replace(/./g, '*')}
        </span>
      </div>
    ),
  },
  {
    title: <ColumnHeader label="Marketing" title={TOOLTIPS.marketing} />,
    render: (row: OtpDto) => <div>{row.marketingConsent ? 'Yes' : 'No'}</div>,
  },
  {
    title: <ColumnHeader label="Subscription" title={TOOLTIPS.statusOtp} />,
    render: (row: OtpDto) => (
      <div>
        <SubscriptionStatus subscriptionStatus={row.status} />
      </div>
    ),
  },
  {
    title: 'One-time Purchase',
    render: (row: OtpDto) => (
      <div className="flex gap-4">
        {row.programs.map((otp) => (
          <Chip
            key={otp.id}
            label={otp.name}
            className="border border-solid border-[#ECEDF2] bg-white text-[#151E34] h-[26px] text-sm"
          />
        ))}
      </div>
    ),
  },
].map((c) => ({ ...c, sorting: false }));

export type OtpTableProps = {
  data: OtpDto[];
  totalResults: number;
};
export function OtpTable({ data, totalResults, ...props }: OtpTableProps) {
  useEffect(() => {
    mixTrack({
      type: 'Viewed OTP Table',
      payload: {},
    });
  }, []);

  return (
    <div className="max-w-full">
      <FiltersBar totalResults={totalResults}>
        <SelectOTPs />
        <SelectSubscriptionStatus />
      </FiltersBar>
      <div className="my-3 text-sm text-[#8A8E99]">
        <Typography>
          Some user details may not appear in this list as they’ve opted to have
          their data hidden per GDPR requirements. This data is solely intended
          for marketing purposes.
        </Typography>
      </div>
      <SimpleTable {...props} columns={columns} data={data} />
    </div>
  );
}
